import {h, Fragment} from "preact"
import { useFacets, useSelectedFiltersCount, useSort } from "@nosto/preact"

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { sortOptions } from "../config"
import { useEffect, useState } from "preact/hooks"



function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for="toggle-mobile-sidebar"
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar() {
    const { loading, facets } = useFacets()

    const { activeSort, setSort } = useSort(sortOptions)
    const [activeFacet, setActiveFacet] = useState('');
    const [selectedItems, setSelectedItems] = useState([]);
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    useEffect(() => {
        if (loading) {
            setActiveFacet('')
        }
    }, [loading])

    useEffect(()=>{
    //     const textToHrefMap = {
    //         'All Best Sellers': '#',
    //         'Best Sellers: Swimwear': '/collections/best-sellers?filter.customFields.producttype=Swim+Bottom%7C%7CSwim+Short%7C%7CSwim+Skirt%7C%7CSwim+Top',
    //         'All Swimwear': '/collections/best-sellers?filter.customFields.producttype=Apparel+Top%7C%7CDress%7C%7COne+Piece%7C%7CPant%7C%7CShort%7C%7CSkirt%7C%7CSkort%7C%7CSweater',
    //         'all swimwear': '#',
    //         'bikinis': '/collections/swimwear?filter.customFields.producttype=Swim+Bottom%7C%7CSwim+bottom%7C%7CSwim+Top',
    //         'swim tops': '/collections/swimwear?filter.customFields.producttype=Swim+Top',
    //         'swim bottoms': '/collections/swimwear?filter.customFields.producttype=Swim+Bottom%7C%7CSwim+bottom',
    //         'one pieces': '/collections/swimwear?filter.customFields.producttype=One+Piece',
    //         'dresses': '/collections/clothing?filter.customFields.producttype=Dress',
    //         'tops': '/collections/clothing?filter.customFields.producttype=Apparel+Top%7C%7CCardigan%7C%7CJacket%7C%7CShirt%7C%7CSweater%7C%7CTop',
    //         'bottoms':'/collections/clothing?filter.customFields.producttype=Apparel+Bottom%7C%7CBike+Short%7C%7CLegging%7C%7CPant%7C%7CSkirt%7C%7CSkort',
    //         'sweaters & knits':'/collections/clothing?filter.customFields.producttype=Sweater%7C%7CCardigan',
    //         'matching sets':'/collections/matching-sets'
    //       };
          
    //       document.querySelectorAll('div[id^="collection-image-filter--template"] .text-ss-14').forEach(el => {
    //         const text = el.textContent.trim();
    //         if (textToHrefMap.hasOwnProperty(text)) {
    //           const parent = el.closest('div.block');
    //           const link = parent?.querySelector('a.link--fill-parent');
    //           if (link) {
    //             link.href = textToHrefMap[text];
    //           }
    //         }
    //       });
    document.querySelectorAll('a.link--fill-parent').forEach(a => {
        if (a.href.includes('?filter.v.availability=1')) {
          a.href = a.href.replace('?filter.v.availability=1', '');
        }
      });
    })

    return facets?.length > 0 ? (
        <>
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for="toggle-mobile-sidebar"
            />
            <div
                class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2"
                style={loading ? "opacity: 0.3;" : ""}
            >
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto ns-d-flex ns-py-4">
                    <div class="ns-sidebar-header ns-d-flex ns-align-items-center ns-p-4">
                    <div class="filter-icon">
                    <svg role="presentation" aria-hidden="true" focusable="false" width="17" height="17" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#231F20" fill-rule="nonzero">
                            <path d="M.59 2.504h2.78a1.92 1.92 0 003.68 0h9.3a.59.59 0 100-1.18H7a1.92 1.92 0 00-3.65 0H.59a.59.59 0 000 1.18zM16.35 7.204h-1.29a1.92 1.92 0 00-3.67 0H.59a.59.59 0 000 1.18h10.8a1.92 1.92 0 003.67 0h1.29a.59.59 0 100-1.18zM16.35 13.674h-6a1.92 1.92 0 00-3.67 0h-6a.595.595 0 000 1.19h6a1.92 1.92 0 003.67 0h6a.595.595 0 000-1.19z"></path>
                        </g>
                    </svg>
                    <span class="visually-hidden">Filter by</span>
                    </div>
                        {/* <ToggleSidebarButton /> */}
                    </div>
                    <div class="ns-sidebar-menu">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0 nosto-facets-list">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet}
                                        isActive={activeFacet === facet.id}
                                        setActive={(active) => {
                                            if (active) {
                                                setActiveFacet(facet.id)
                                            } else {
                                                setActiveFacet('')
                                            }
                                        }}
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems} />
                                    case "stats":
                                        return <RangeFacet facet={facet} isActive={activeFacet === facet.id}
                                        setActive={(active) => {
                                            if (active) {
                                                setActiveFacet(facet.id)
                                            } else {
                                                setActiveFacet('')
                                            }
                                        }}
                                        selectedItems={selectedItems}
                                        setSelectedItems={setSelectedItems} />
                                    default:
                                        return null
                                }
                            })}
                            <li class="ns-sidebar-dropdown nosto-dropdown-container">
                            <Select
                                    value={activeSort}
                                    onChange={e => handleSortChange(e)}
                                    className="ns-selection-dropdown-sort-menu"
                                    options={options}
                                />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
